<router-outlet />
<!-- Mobile: default 25rem width overflows narrow screens; span the viewport with a 1rem gutter instead. -->
<p-toast position="bottom-right" [breakpoints]="{ '639px': { width: 'auto', left: '1rem', right: '1rem' } }" />
